import { render, staticRenderFns } from "./BusinessBalance.vue?vue&type=template&id=0bc06590"
import script from "./BusinessBalance.vue?vue&type=script&lang=js"
export * from "./BusinessBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports